enum Direction {
  Outbound = 'outbound',
  Inbound = 'inbound',
}

export default Direction;
